<template>
  <v-card>
    <v-toolbar dark dense flat :color="orderStatusColorById(order.status)">
      <v-toolbar-title>{{ order._id }} ({{ travelerById(order.traveler) }})</v-toolbar-title>
      <v-spacer />
      <v-chip
        class="ma-2"
        :color="orderStatusColorById(order.status)"
        dark
      >{{ orderStatusById(order.status) }}</v-chip>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row class="wrap">
          <v-col cols="12" md="4">
            <h3 class="body-2 grey--text">תאריכי הזמנה מקוריים</h3>
            <span
              class="title black--text"
            >{{ format(order.originalEndDate, 'DD/MM/YY') }} - {{ format(order.originalStartDate, 'DD/MM/YY') }}</span>
          </v-col>
          <v-col cols="12" md="4">
            <h3 class="body-2 grey--text">תאריכים קובעים לחיוב</h3>
            <span
              class="title black--text"
            >{{ format(order.endDate, 'DD/MM/YY') }} - {{ format(order.startDate, 'DD/MM/YY') }}</span>
          </v-col>
          <v-col cols="12" md="4">
            <h3 class="body-2 grey--text">תאריך יצירה</h3>
            <span class="title black--text">{{ heDate(order.created,false, true) }}</span>
          </v-col>
          <v-col cols="12" md="4">
            <h3 class="body-2 grey--text">ימי השכרה מקוריים</h3>
            <span class="title black--text">{{ Math.abs(originalTotalDays) }}</span>
          </v-col>
          <v-col cols="12" md="4">
            <h3 class="body-2 grey--text">ימי השכרה בפועל</h3>
            <span class="title black--text">{{ Math.abs(actualTotalDays) }}</span>
          </v-col>
          <v-col cols="12" md="4">
            <h3
              class="body-2 grey--text"
            >{{ totalDaysDiff > 0 ? 'ימים נוספים לחיוב' : 'ימים לזיכוי' }}</h3>
            <span class="title black--text">{{ Math.abs(totalDaysDiff) }}</span>
          </v-col>
          <v-col cols="12" md="4" v-if="order.receiveType">
            <h3 class="body-2 grey--text">סוג מכירה</h3>
            <span
              class="title black--text"
            >{{agentTypeById(order.agentType) == null ? 'עצמאי' :agentTypeById(order.agentType)}}</span>
          </v-col>
          <v-col cols="12" md="4" v-if="order.receiveType">
            <h3 class="body-2 grey--text">סוג מסירה</h3>
            <span class="title black--text">{{ receiveTypeById(order.receiveType) }}</span>
          </v-col>
          <v-col cols="12" md="4" v-if="order.shipmentStore">
            <h3 class="body-2 grey--text">סניף למסירה</h3>
            <span class="title black--text">{{ storeTypeById(order.shipmentStore) }}</span>
          </v-col>
          <v-col cols="12" md="4" v-if="order.receiveType">
            <h3 class="body-2 grey--text">סך תשלומים</h3>
            <span
              class="title black--text"
            >{{ (order.totalPayments / 100).toLocaleString('he-IL', { style: 'currency', currency: 'ILS' }) }}</span>
          </v-col>
          <v-col cols="12" md="4" v-if="order.shekelToDollarRatio">
            <h3 class="body-2 grey--text">שער הדולר</h3>
            <span class="title black--text">{{ order.shekelToDollarRatio }}</span>
          </v-col>
          <v-col cols="12" md="4" v-if="order.mapSharePassword">
            <h3 class="body-2 grey--text">מפה אישית</h3>
            <span class="title black--text">
              {{ order.mapSharePassword }}
              <v-btn
                :href="`https://sar.rescue-1.co.il/map/${order._id}`"
                tag="a"
                target="_blank"
                icon
                small
              >
                <v-icon>mdi-link</v-icon>
              </v-btn>
            </span>
          </v-col>
          <v-col cols="12" md="4">
            <h3 class="body-2 grey--text">טופס פרטי חירום</h3>
            <span class="title black--text">
              <v-btn
                :href="`https://sar.rescue-1.co.il/traveler-form/${order.transactionId}`"
                tag="a"
                target="_blank"
                icon
                small
              >
                <v-icon>mdi-link</v-icon>
              </v-btn>
            </span>
          </v-col>
          <v-col cols="12" md="4" v-if="order.coupon">
            <h3 class="body-2 grey--text">קופון</h3>
            <span class="title black--text">{{ couponById(order.coupon) }}</span>
          </v-col>
          <v-col cols="12" md="4" v-if="order.deliveryItem">
            <h3 class="body-2 grey--text">משלוח</h3>
            <span class="title black--text">
              {{heDate(order.deliveryItem.date)}}
              <v-btn
                :href="`https://inreach.rescue-1.co.il/deliveries/${order.deliveryItem.delivery}`"
                tag="a"
                target="_blank"
                icon
                small
              >
                <v-icon>mdi-link</v-icon>
              </v-btn>
            </span>
          </v-col>
          <v-col cols="12" md="4" v-if="order.device">
            <h3 class="body-2 grey--text">מכשיר</h3>
            <span class="title black--text">
              <router-link :to="`/devices/${order.device}`">{{ deviceById(order.device) }}</router-link>
            </span>
          </v-col>
          <v-col cols="12" md="4" v-if="order.dataUsage">
            <h3 class="body-2 grey--text">שימוש בנתונים</h3>
            <span class="title black--text">{{ (order.dataUsage.totalBytes) + ' בייטים' }}</span>
          </v-col>
          <v-col cols="12" md="4" v-if="order.shipmentAddress">
            <h3 class="body-2 grey--text">כתובת למשלוח</h3>
            <span class="title black--text">{{ order.shipmentAddress + ", " + order.shipmentCity + ", מיקוד- " + order.shipmentZipCode}}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-divider />
    <v-simple-table>
      <thead>
        <tr>
          <th></th>
          <th>סוג סוכן</th>
          <th>מזהה סוכן</th>
          <th>מזהה חנות</th>
          <th>הערות סוכן</th>
          <th>הערות לקוח</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>השכרה</td>
          <td>{{ agentTypeById(order.agentType) }}</td>
          <td>{{ order.agentId }}</td>
          <td>{{ order.agentStore }}</td>
          <td></td>
          <td></td>
        </tr>
        <tr v-if="order.bookOutAgentType">
          <td>מסירה</td>
          <td>{{ agentTypeById(order.bookOutAgentType) }}</td>
          <td>{{ order.bookOutAgentId }}</td>
          <td>{{ order.bookOutAgentStore }}</td>
          <td>{{ order.bookOutAgentComments }}</td>
          <td>{{ order.bookOutCustomerComments }}</td>
        </tr>
        <tr v-if="order.checkInAgentType">
          <td>החזרה</td>
          <td>{{ agentTypeById(order.checkInAgentType) }}</td>
          <td>{{ order.checkInAgentId }}</td>
          <td>{{ order.checkInAgentStore }}</td>
          <td>{{ order.checkInAgentComments }}</td>
          <td>{{ order.checkInCustomerComments }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
import { format, differenceInCalendarDays } from "date-fns";
import Mixins from "@/mixins/mixins";
// import shouldShow from "@/utils/shouldShow";

export default {
  data() {
    return {
      removing: []
    };
  },
  computed: {
    totalDaysDiff() {
      let trueDiff = differenceInCalendarDays(
        this.order.startDate,
        this.order.endDate
      );
      let originalDiff = differenceInCalendarDays(
        this.order.originalStartDate,
        this.order.originalEndDate
      );
      let totalDiff = Math.abs(trueDiff) - Math.abs(originalDiff);

      return totalDiff;
    },
    originalTotalDays() {
      let totalDays = differenceInCalendarDays(
        this.order.originalStartDate,
        this.order.originalEndDate
      );
      return totalDays;
    },
    actualTotalDays() {
      let totalDays = differenceInCalendarDays(
        this.order.startDate,
        this.order.endDate
      );
      return totalDays;
    }
  },
  props: ["order"],
  watch: {},
  mounted() {},
  methods: {
    format,
    orderStatusById(id) {
      if (id) {
        let item = this.$store.state.entities.orderStatuses[id];
        if (item) {
          return item.title;
        }
      }
    },
    orderStatusColorById(id) {
      if (id) {
        let item = this.$store.state.entities.orderStatuses[id];
        if (item) {
          return item.color;
        }
      }
      return "black";
    },
    couponById(id) {
      if (id) {
        let item = this.$store.state.entities.coupons[id];
        if (item) {
          return item.name;
        }
      }
    },
    receiveTypeById(id) {
      if (id) {
        let item = this.$store.state.entities.receiveTypes[id];
        if (item) {
          return item.title;
        }
      }
    },
    storeTypeById(id) {
      if (id) {
        let item = this.$store.state.entities.stores[id];
        if (item) {
          return item.title;
        }
      }
    },
    deviceById(id) {
      if (id) {
        let item = this.$store.state.entities.devices[id];
        if (item) {
          return item.imei;
        }
      }
    },
    agentTypeById(id) {
      if (id) {
        let item = this.$store.state.entities.agentTypes[id];
        if (item) {
          return item.title;
        }
      }
    },
    travelerById(id) {
      if (id) {
        let item = this.$store.state.entities.customers[id];
        if (item) {
          return item.name;
        }
      }
    }
  },
  components: {},
  mixins: [Mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>